import Overview from './overview.vue';
import Full from './FullIndex.vue';
import Detail from '@rebuild/materials/shared/report/DetailIndex.vue';
import MobOverview from '@rebuild/materials/shared/report/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/report/MobFullIndex.vue';
import MobDetail from '@rebuild/materials/shared/report/MobDetail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail,
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
};
